module.exports = __webpack_public_path__ + "src/assets/img/SoccerGoldBUSD.8e1033d3.png";